/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import styled from 'styled-components';
import {baseBlue} from '../../../../constants/colors';
import {selectGlobalVariableListState, setIsModelUsageDialogOpen} from '../../../../redux/ducks/ScenarioAnalysis/slice';
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks';
import ModelUsage from './ModelUsage';
import CloseIcon from '@mui/icons-material/Close';
import {IconButton, Typography} from '@mui/material';
import AppBar from '../../../components/AppBar/AppBar';


const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
})


const Header = styled.div({
  display: 'flex',
  backgroundColor: baseBlue
})


/**
 * Renders the Model Usage dialog window on the View Variables page
 */
const ModelUsageDialog = () => {
  const dispatch = useAppDispatch()
  const variableData = useAppSelector(state => selectGlobalVariableListState(state).variableModelUsageData)
  const variableName = variableData.variableName
  const displayName = variableData.displayName
  
  const onClickClose = () => {
    dispatch(setIsModelUsageDialogOpen(false))
  }

  const dialogActions = (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <IconButton onClick={onClickClose} sx={{color: 'white', padding: 0, fontSize: 'small'}}> 
        <CloseIcon />
      </IconButton>
    </div>
  )

  return (
    <Container>
      <div>
        <AppBar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#ffffff'}}>
            Models that contain "{displayName === "" || displayName == null ? variableName : displayName}"
          </Typography>
          {dialogActions}
        </AppBar>
      </div>
      <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%'}}>
        <ModelUsage/>
      </div>
    </Container>
  )
}

export default ModelUsageDialog
